import { render, staticRenderFns } from "./information-sanitaire.vue?vue&type=template&id=23cff706&scoped=true&"
import script from "./information-sanitaire.vue?vue&type=script&lang=ts&"
export * from "./information-sanitaire.vue?vue&type=script&lang=ts&"
import style0 from "./information-sanitaire.vue?vue&type=style&index=0&id=23cff706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cff706",
  null
  
)

export default component.exports